/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Swift_Soft_Marlin_ComfortInputs */

const fr_swift_soft_marlin_comfort = /** @type {(inputs: Swift_Soft_Marlin_ComfortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`⚠️ Attention: Aucun type d'événement sélectionné. L'utilisateur n'aura accès à aucun événement.`)
};

/**

* @param {Swift_Soft_Marlin_ComfortInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const swift_soft_marlin_comfort = /** @type {((inputs?: Swift_Soft_Marlin_ComfortInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Swift_Soft_Marlin_ComfortInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_swift_soft_marlin_comfort(inputs)
});